import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FolderKanban } from "lucide-react";

export default function AdminBatchPage({
  centersList,
  selectedCenterForBatch,
  setSelectedCenterForBatch,
  fetchCenterBatches,
  newBatchName,
  setNewBatchName,
  handleCreateBatch,
  centerBatches,
}) {
  return (
    <Card className="shadow-lg">
      <CardHeader className="border-b">
        <CardTitle className="flex items-center gap-2 text-lg">
          <FolderKanban className="w-5 h-5 text-blue-600" />
          Batch Management
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4 space-y-4">
        <form onSubmit={handleCreateBatch} className="space-y-3">
          <div className="space-y-2">
            <Label>Select Center</Label>
            <select
              className="w-full h-10 px-3 rounded-md border border-slate-300 bg-white"
              value={selectedCenterForBatch}
              onChange={(event) => {
                setSelectedCenterForBatch(event.target.value);
                fetchCenterBatches(event.target.value);
              }}
            >
              <option value="">-- Select a Center --</option>
              {centersList.map((center) => (
                <option key={center.id} value={center.id}>
                  {center.name}
                </option>
              ))}
            </select>
          </div>
          <div className="space-y-2">
            <Label htmlFor="batch-name">Batch Name</Label>
            <Input
              id="batch-name"
              value={newBatchName}
              onChange={(event) => setNewBatchName(event.target.value)}
              placeholder="Evening Batch"
              required
            />
          </div>
          <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700">
            Create Batch
          </Button>
        </form>

        <div className="space-y-2 max-h-80 overflow-y-auto">
          {centerBatches.length === 0 ? (
            <p className="text-sm text-slate-500">No batches for this center.</p>
          ) : (
            centerBatches.map((batch) => (
              <div key={batch.id} className="rounded-lg border border-slate-200 p-3 bg-slate-50">
                <p className="font-medium text-slate-900">{batch.name}</p>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
}